
import { appConfig } from './app-config';

/**
 * Environment configuration - now powered by AppConfig
 * Values are read from .env file, with localStorage overrides via AppConfig
 * Change values in .env or through Settings page without modifying code
 */
export const env = {
  /** Backend API URL (Worker proxy) - managed by AppConfig key: app_config_backend_url */
  get apiUrl(): string { return appConfig.backendUrl; },
  /** Odoo instance URL - managed by AppConfig key: app_config_odoo_url */
  get odooUrl(): string { return appConfig.odooUrl; },
  /** Odoo database name - managed by AppConfig key: app_config_odoo_db */
  get odooDb(): string { return appConfig.odooDb; },
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY || '',
  },
} as const;
